export const why_constants = [
  "Support for multiple annotation formats (COCO, YOLO, Pascal VOC)",
  "Quality assurance through multi-tier validation",
  "Fast turnaround times with scalable workforce",
  "Domain expertise in African market contexts",
];

export const industries_constants = {
  title: "Industries We Serve",
  services: [
    {
      id: "Agriculture",
      title: "Agriculture",
      description:
        "Optimizing food production and sustainability through data-driven precision farming.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.6 3C9.021 3 11.1216 4.3653 12.1773 6.3669C13.2366 4.8747 14.979 3.9 16.95 3.9H20.1V6.15C20.1 9.381 17.481 12 14.25 12H12.9V12.9H17.4V19.2C17.4 20.1945 16.5945 21 15.6 21H8.4C7.4055 21 6.6 20.1945 6.6 19.2V12.9H11.1V11.1H9.3C5.8206 11.1 3 8.2794 3 4.8V3H6.6ZM15.6 14.7H8.4V19.2H15.6V14.7ZM18.3 5.7H16.95C14.7135 5.7 12.9 7.5135 12.9 9.75V10.2H14.25C16.4865 10.2 18.3 8.3865 18.3 6.15V5.7ZM6.6 4.8H4.8C4.8 7.2849 6.8151 9.3 9.3 9.3H11.1C11.1 6.8151 9.0849 4.8 6.6 4.8Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      id: "Healthcare",
      title: "Healthcare",
      description:
        "Transforming patient care with intelligent diagnostics, treatment insights, and operational efficiency.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3 12H21"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.75 12C15.75 18 12 21 12 21C12 21 8.25 18 8.25 12C8.25 6 12 3 12 3C12 3 15.75 6 15.75 12Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "Lifestyle",
      title: "Lifestyle",
      description:
        "Enhancing everyday experiences with AI-powered personalization and smart recommendations.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 12C16.5563 12 20.25 9.98528 20.25 7.5C20.25 5.01472 16.5563 3 12 3C7.44365 3 3.75 5.01472 3.75 7.5C3.75 9.98528 7.44365 12 12 12Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 7.5V12C3.75 14.4853 7.44375 16.5 12 16.5C16.5562 16.5 20.25 14.4853 20.25 12V7.5"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 12V16.5C3.75 18.9853 7.44375 21 12 21C16.5562 21 20.25 18.9853 20.25 16.5V12"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "Security & Surveillance",
      title: "Security & Surveillance",
      description:
        "Strengthening safety with real-time AI-powered monitoring, threat detection, and incident response.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.06543 7.21124L11.9998 12.1012L20.9342 7.21124"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.36 2.34376L20.61 6.86063C20.7278 6.92509 20.8261 7.01999 20.8947 7.13542C20.9633 7.25086 20.9997 7.3826 21 7.51688V16.4831C20.9997 16.6174 20.9633 16.7492 20.8947 16.8646C20.8261 16.98 20.7278 17.0749 20.61 17.1394L12.36 21.6563C12.2496 21.7167 12.1258 21.7483 12 21.7483C11.8742 21.7483 11.7504 21.7167 11.64 21.6563L3.39 17.1394C3.2722 17.0749 3.17386 16.98 3.10526 16.8646C3.03666 16.7492 3.0003 16.6174 3 16.4831V7.51688C3.0003 7.3826 3.03666 7.25086 3.10526 7.13542C3.17386 7.01999 3.2722 6.92509 3.39 6.86063L11.64 2.34376C11.7504 2.28336 11.8742 2.25171 12 2.25171C12.1258 2.25171 12.2496 2.28336 12.36 2.34376Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 12.1022V21.75"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      id: "Retail & E-commerce",
      title: "Retail & E-commerce",
      description:
        "Driving sales and loyalty through behaviour-based personalization and predictive analytics.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M6.6 3C9.021 3 11.1216 4.3653 12.1773 6.3669C13.2366 4.8747 14.979 3.9 16.95 3.9H20.1V6.15C20.1 9.381 17.481 12 14.25 12H12.9V12.9H17.4V19.2C17.4 20.1945 16.5945 21 15.6 21H8.4C7.4055 21 6.6 20.1945 6.6 19.2V12.9H11.1V11.1H9.3C5.8206 11.1 3 8.2794 3 4.8V3H6.6ZM15.6 14.7H8.4V19.2H15.6V14.7ZM18.3 5.7H16.95C14.7135 5.7 12.9 7.5135 12.9 9.75V10.2H14.25C16.4865 10.2 18.3 8.3865 18.3 6.15V5.7ZM6.6 4.8H4.8C4.8 7.2849 6.8151 9.3 9.3 9.3H11.1C11.1 6.8151 9.0849 4.8 6.6 4.8Z"
            fill="white"
          />
        </svg>
      ),
    },
    {
      id: "Fintech & Finance",
      title: "Fintech & Finance",
      description:
        "Monitor waste levels, track environmental changes, and support sustainability initiatives.",
      icon: () => (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3.06543 7.21124L11.9998 12.1012L20.9342 7.21124"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.36 2.34376L20.61 6.86063C20.7278 6.92509 20.8261 7.01999 20.8947 7.13542C20.9633 7.25086 20.9997 7.3826 21 7.51688V16.4831C20.9997 16.6174 20.9633 16.7492 20.8947 16.8646C20.8261 16.98 20.7278 17.0749 20.61 17.1394L12.36 21.6563C12.2496 21.7167 12.1258 21.7483 12 21.7483C11.8742 21.7483 11.7504 21.7167 11.64 21.6563L3.39 17.1394C3.2722 17.0749 3.17386 16.98 3.10526 16.8646C3.03666 16.7492 3.0003 16.6174 3 16.4831V7.51688C3.0003 7.3826 3.03666 7.25086 3.10526 7.13542C3.17386 7.01999 3.2722 6.92509 3.39 6.86063L11.64 2.34376C11.7504 2.28336 11.8742 2.25171 12 2.25171C12.1258 2.25171 12.2496 2.28336 12.36 2.34376Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 12.1022V21.75"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ],
};
